import { z } from "zod";
import { UPLOAD, NAME } from "./consts";

export const addSchema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
  [UPLOAD]: z.any(),
});

export type AddModelFormValues = z.infer<typeof addSchema>;
